







































import axios from 'axios';
import Vue from 'vue';

const emailRegex = /\S+@\S+\.\S+/;

export default Vue.extend({
  data() {
    return {
      email: '' as string,
      loading: false,
      error: '',
      message: ''
    };
  },
  methods: {
    async onClick() {
      this.message = '';

      const isValid = emailRegex.test(this.email);

      if (!isValid) {
        this.error = 'Please enter a valid email address.';
        return;
      }

      this.error = '';
      this.loading = true;

      try {
        await axios.post('https://appget.net/.netlify/functions/subscribe', [
          {
            email: this.email
          }
        ]);
        this.message = 'Thanks for subscribing. We\'ll be in touch';
      } catch (ex) {
        this.error = ex.message;
      }
      this.loading = false;
    }
  }
});
